exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom {\n  padding-top: 22px; }\n\n.panel {\n  box-shadow: none;\n  margin-bottom: auto; }\n\n.btn {\n  margin-right: 1.3em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/business-info/business-info.component.scss
// module id = ../../../../../src/app/routes/restaurant/business-info/business-info.component.scss
// module chunks = main